import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { InvestigationDashboardRepository } from '../../../infrastructure/repositories/investigation-dashboard.repository';
import { GetInvestigationDashboardPreferencesResult } from './get-investigation-dashboard-preferences.result';

@Injectable({ providedIn: 'root' })
export class GetInvestigationDashboardPreferencesUseCase {
  private readonly _repository = inject(InvestigationDashboardRepository);

  public execute(): Observable<GetInvestigationDashboardPreferencesResult> {
    return this._repository.getMe().pipe(map((preferences) => ({ preferences })));
  }
}
